import React from 'react';
type MonogramProps = {
  className?: string;
  tone?: 'light' | 'dark';
};
export function Monogram({
  className = 'h-9 w-9',
  tone = 'light'
}: MonogramProps) {
  return <svg viewBox="0 0 40 40" fill="none" aria-hidden="true" className={className} data-id="element-32" data-mp="28p0ne8b0je7h">
      <path d="M6.5 34 L20 6 L33.5 34" stroke={tone === 'light' ? '#FFFFFF' : '#0B1530'} strokeWidth="2.25" strokeLinejoin="miter" data-id="element-33" data-mp="28mxoeyrvuaqm" />
      <path d="M11.4 24.5 H38" stroke="#C8A65D" strokeWidth="2" data-id="element-34" data-mp="2ho5j76v6wtfy" />
    </svg>;
}